import { Injectable } from '@angular/core';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthService } from '@open-portal-app/core/services/auth.service';
import { UserDataService } from '@open-portal-app/core/services/user-data.service';

@Injectable({
  providedIn: 'root'
})
export class UserDataResolver implements Resolve<any> {
  constructor(
    private authService: AuthService,
    private userDataService: UserDataService
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>|Promise<any>|any {
    const isAuthenticated = this.authService.isAuthenticated();

    return isAuthenticated ? this.userDataService.getUserData() : null
  }
}
